import { render } from "./HeroiconsOutlineDocumentDuplicate.vue?vue&type=template&id=c27ba766"
const script = {}

import exportComponent from "/home/nginx/domains/tools.androidrepublic.org/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDocumentDuplicate.vue"]])

export default __exports__